export const getInitialWarehouseTitle = (t: (key: string) => string) =>
    t('AddWarehouseButton.constructor.inputValue');
